import script from "./Table.vue?vue&type=script&setup=true&lang=js"
export * from "./Table.vue?vue&type=script&setup=true&lang=js"

import "./Table.vue?vue&type=style&index=0&id=af34a764&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af34a764"]])

export default __exports__